// a place for stateless functions
import {
    GET_UI_TEXT_BY_KEY,
    GET_BODY_TEXT_BY_KEY,
} from './constants'

//takes any type of entry
function mapEntry(entry) {
    let mappedEntry = {}
    if (entry.fields) {
        entry.fields.forEach(field => {
            mappedEntry[field.key] = castField(field)
        })
    }
    mappedEntry['id'] = entry.id
    mappedEntry['created'] = entry.created
    mappedEntry['updated'] = entry.updated
    return mappedEntry
}

// takes a field
function castField(field) {
    switch (field.type) {
        case 'boolean':
            return field.value === 'true'
        case 'number':
            return field.value ? Number(field.value) : null
        case 'reference':
            return field.value ? mapEntry(field.value) : null
        case 'reference_multi':
            return field.value ? field.value.map(eachEntry => {
                return mapEntry(eachEntry)
            }) : null
        default:
            return field.value ? field.value : null
    }
}

//sorts entries by a given field
function sortEntriesByFactory(fieldName) {
    return function sortEntries(entryA, entryB) {
        if (entryA[fieldName] < entryB[fieldName]) {
            return -1;
        }
        if (entryA[fieldName] > entryB[fieldName]) {
            return 1;
        }
        // a must be equal to b
        return 0;
    }
}

function sortMasechtot(masechetA, masechetB) {
    const fieldName = 'order'
    if (masechetA.seder[fieldName] < masechetB.seder[fieldName]) {
        return -1;
    }
    if (masechetA.seder[fieldName] > masechetB.seder[fieldName]) {
        return 1;
    }
    if (masechetA.seder[fieldName] === masechetB.seder[fieldName]) {
        return sortEntriesByFactory(fieldName)(masechetA, masechetB)
    }
    return 0;
}

// takes a product
function minPrice(product) {
    return Math.min(...product.variant.map(eachVariant => {
        return eachVariant.price
    }))
}

// takes a product
function maxPrice(product) {
    return Math.max(...product.variant.map(eachVariant => {
        return eachVariant.price
    }))
}

function variantLabels(product) {
    return product.variant.map(eachVariant => {
        return eachVariant.short_name
    })
}

function uiTextGetter(store, key) {
    const result = store.getters[GET_UI_TEXT_BY_KEY](key)
    return result ? result.value : ''
}

function bodyTextGetter(store, key) {
    const result = store.getters[GET_BODY_TEXT_BY_KEY](key)
    return result ? result.value : ''
}


function parseJSONOrNull(jsonString) {
    let outObj = null
    try {
        outObj = JSON.parse(jsonString)
    } catch (e) {

    }
    return outObj
}

function numToHebrewLetter(num) {
    const a = {}
    a["א"] = 1
    a["ב"] = 2
    a["ג"] = 3
    a["ד"] = 4
    a["ה"] = 5
    a["ו"] = 6
    a["ז"] = 7
    a["ח"] = 8
    a["ט"] = 9
    a["י"] = 10
    a["כ"] = 20
    a["ל"] = 30
    a["מ"] = 40
    a["נ"] = 50
    a["ס"] = 60
    a["ע"] = 70
    a["פ"] = 80
    a["צ"] = 90
    a["ק"] = 100
    a["ר"] = 200
    a["ש"] = 300
    a["ת"] = 400
    const c = Object.keys(a);
    c.sort()
    c.reverse()

    function nextNumberGematriya(someNumber, str) {
        // find max allowed value >= n
        if (someNumber === 0) {
            return str
        }
        for (let i = 0; i < c.length; i++) {
            const value = a[c[i]]
            if (value <= someNumber) {
                return nextNumberGematriya(someNumber - value, str += c[i])
            }
        }
    }

    return nextNumberGematriya(num, '').replace('יה', 'טו').replace('יו', 'טז')
}

// takes a Date
function daysInMonth(d) {
    return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
}

const Helpers = {
    mapEntry: mapEntry,
    sortEntriesByFactory: sortEntriesByFactory,
    sortMasechtot: sortMasechtot,
    minPrice: minPrice,
    maxPrice: maxPrice,
    variantLabels: variantLabels,
    uiTextGetter: uiTextGetter,
    bodyTextGetter: bodyTextGetter,
    parseJSONOrNull: parseJSONOrNull,
    numToHebrewLetter: numToHebrewLetter,
    daysInMonth: daysInMonth,
};

export default Helpers

